const showMoreOptions = () => {
    const toggle = document.querySelector('#showMoreOptionsLink');
    if (!toggle) {
        return false;
    }
    const text = toggle.querySelector('#text');
    const icon = toggle.querySelector('.fa-solid');
    const options = document.querySelectorAll('.product-page__props__option');
    const handler = (event) => {
        event.preventDefault();
        const status = toggle.dataset.status;
        if (status == 'hide') {
            options.forEach(option => {
                option.classList.remove('hide');
            });
            toggle.dataset.status = 'show';
            text.innerHTML = 'Скрыть';
            icon.classList.add('fa-rotate-180');
        }
        else {
            options.forEach((option, key) => {
                if (key > 3) {
                    option.classList.add('hide');
                }
            });
            toggle.dataset.status = 'hide';
            text.innerHTML = 'Показать больше опций';
            icon.classList.remove('fa-rotate-180');
        }
    };
    toggle && toggle.addEventListener('click', handler);
};
export default showMoreOptions;
